<script>
  import FlowerBgSection from "$lib/components/FlowerBgSection.svelte";
  import Banner from "$lib/components/home/Banner.svelte";
  import ListProducts from "$lib/components/home/ListProducts.svelte";
  import { addEventListeners } from "$lib/utils/events.js";
  import { afterUpdate } from "svelte";

  export let data;

  const softgelImg = {
    img: "/images/home/soft-gel.webp",
    img2x: "/images/home/soft-gel@2x.webp",
    img3x: "/images/home/soft-gel@3x.webp",
  };

  const fortifyProtectImg = {
    img: "/images/home/flash_glitter.webp",
    img2x: "/images/home/flash_glitter@2x.webp",
    img3x: "/images/home/flash_glitter@3x.webp",
  };

  afterUpdate(() => {
    addEventListeners();
  });
</script>

<svelte:head>
  <title>Red Carpet Manicure</title>
</svelte:head>
<div class="body">
  <div class="banner">
    <Banner />
  </div>
  <div class="home-container">
    <ListProducts title="New Arrivals" productList={data.results} />
    <FlowerBgSection title="Soft Gel" description="Fastest at home enhancement ever!" text="We dare you to take a closer look. Nails so seamless only you will know they aren’t yours." link="/soft-gel" image={softgelImg} />
    <div class="best-sellers">
      <ListProducts title="Best Sellers" productList={data.results} />
    </div>
    <div class="last-section">
      <div class="flowerSection">
        <FlowerBgSection
          title="Flash Glitter"
          description="Get the perfect selfie ready look!"
          text="Snap a photo with flash photography. The end result? A gorgeous manicure with an out-of-this-world sparkle!"
          link="/collections/flash-glitter"
          image={fortifyProtectImg}
          isOrange={false}
        />
      </div>
      <div class="text-shipping">
        <p><strong>SHOP NOW! FREE DELIVERY</strong> ON ALL ORDERS OVER £25!</p>
      </div>
    </div>
  </div>
</div>

<style>
  .body {
    width: 100svw;
    overflow: hidden;
  }
  .banner {
    position: relative;
    z-index: 13;
  }
  .home-container {
    position: relative;
    background-color: var(--orange-light);
    z-index: 12;
  }
  .best-sellers {
    margin-top: -10rem;
    position: relative;
    z-index: -1;
  }
  .last-section {
    position: relative;
  }
  .flowerSection {
    margin-bottom: -8rem;
  }
  .text-shipping {
    width: 100svw;
    padding: 8rem 0;
    background-color: var(--orange-light);
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 12.55/1;
  }
  .text-shipping p {
    text-align: center;
    color: var(--red);
    font-size: clamp(2.5rem, 4svw, 6rem);
    line-height: 1;
  }
  .text-shipping p strong {
    font-weight: 700;
  }
</style>
